import React from 'react';

const PromotionCard = ({ promotion }) => {
  const cardClasses = ['card', promotion.cardColor ? `bg-${promotion.cardColor}` : ''].join(' ');

  return (
    <div className={cardClasses}>
      <div className="body">
        <div className="title">{promotion.nombre}</div>
        <p className="meta">Vigencia: {promotion.vigencia}</p>
        <p className='muted'>{promotion.descripcion}</p>
        {promotion.condiciones && <p><small className="muted">{promotion.condiciones}</small></p>}
        {promotion.url && <a href={promotion.url} download className="btn primary">Descargar Flyer</a>}
      </div>
    </div>
  );
};

export default PromotionCard;